import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  category: [],
  loading: false,
  editCategoryNameLoading: false,
  editSubCategoryNameLoading: false,
  delCategoryBtnLoading: false,
  delSubCategoryBtnLoading: false,
  editCategoryBtnLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UTILITY_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
